import { Link } from "react-router-dom";
import { categorySlugMap } from "@/mocks/categories";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function getCategoryBreadcrumb(slug: string): BreadcrumbItem[] {
  const name = categorySlugMap[slug] || slug;
  return [
    { label: "首页", href: "/" },
    { label: name, href: `/category/${slug}` },
  ];
}

export function getArticleBreadcrumb(
  categorySlug: string,
  articleTitle: string,
): BreadcrumbItem[] {
  const catName = categorySlugMap[categorySlug] || categorySlug;
  return [
    { label: "首页", href: "/" },
    { label: catName, href: `/category/${categorySlug}` },
    { label: articleTitle },
  ];
}

export function getAboutBreadcrumb(currentLabel?: string): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [
    { label: "首页", href: "/" },
    { label: "关于我们", href: "/about" },
  ];
  if (currentLabel) {
    items.push({ label: currentLabel });
  }
  return items;
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-600">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
          )}
          {item.href ? (
            <Link
              to={item.href}
              className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium whitespace-nowrap">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}